var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMovementTypeArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.85,
    height: 18.53,
    viewBox: "0 0 19.85 18.53",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    transform: "translate(0.791 0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M17.93,23.926l-17-7.847a.657.657,0,0,0-.782.183.65.65,0,0,0-.016.8L5.722,24.52.131,31.974a.654.654,0,0,0,.8.986l17-7.847a.654.654,0,0,0,0-1.187Z",
    transform: "translate(0 -16.02)",
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 1.5
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMovementTypeArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/movement_type_arrow.d1425218.svg";
export { ForwardRef as ReactComponent };